<form class="form-inline">
  <div class="form-group mx-sm-6 mb-6" style="margin-bottom: 20px">
    <label style="margin-right: 20px">Durée d'arrêt hors P.O.I (min)</label>

    <select *ngIf="stopTimeSelectMode" class="form-control" [(ngModel)]="nonPoiAlertConfiguration.value2"
            name="stopTime"
            (ngModelChange)="chooseStopTime($event)" style="width: 70px;border-radius: 10px">
      <option *ngFor="let minute of minutes" [ngValue]="minute" style="font-size: 14px;"
              [ngClass]="{'autre': minute == 'Autre..'}">
        {{minute}}
      </option>
    </select>

    <input *ngIf="!stopTimeSelectMode" type="number" name="stopTime" [(ngModel)]="stopTime" class="form-control"
           placeholder="Durée d'arrêt">

    <i *ngIf="!stopTimeSelectMode" class="fa fa-times" style="color: #aa1111"
       (click)="stopTimeSelectMode = true;nonPoiAlertConfiguration.value2='10'"></i>


  </div>


<!-------------------------Email---------------------------------->
   <app-email-manager [enableGlobalConfigToAllVehicules]="enableGlobalConfigToAllVehicules" [emailMode]="alert.emailMode" [enableGlobalConfig]="enableGlobalConfig" [emailsHash]="alert.emails"
                     (onChange)="emailSettings($event)"></app-email-manager>

  <div
  style="margin-top: -27px;margin-left: 457px"><label style="margin-right: 4px">Active/Désactive</label>  <mat-slide-toggle [(ngModel)]="alert.isActive" name="isActive" style=""></mat-slide-toggle>
  </div>


<br>
<div class="advanced-link">
  <span *ngIf="!showAdvancedSettings" (click)="collapseAdvancedSettings()">
            <span class="link" style="margin-right: 5px;text-decoration: none">paramétrage avancé</span>     <i class="fa fa-plus-square"></i>
            </span>
</div >

  <div class="advanced-link">
    <span *ngIf="showAdvancedSettings" (click)="collapseAdvancedSettings()">
              <span class="link" style="margin-right: 5px;text-decoration: none">masquer paramétrage avancé</span>
      <i class="fa fa-minus-square"></i>
            </span></div>


  <br style="margin-left: 10px" *ngIf="showAdvancedSettings">
  <br style="margin-left: 10px" *ngIf="showAdvancedSettings">
  <div style="margin-top: 10px;margin-left: 25px">
    <app-cron-settings *ngIf="showAdvancedSettings" [cron]="cronAlertConfiguration"></app-cron-settings>

  </div>

  <br>



  <!--------------------la button save---------------------------->
  <button type="submit" class="btn btn-flat btn-primary mb-2" (click)="save()" style="border-radius: 15px;margin-left: 500px">
      <ngx-loading [show]="loader" [config]="{ backdropBorderRadius: '0px',fullScreenBackdrop:true }"></ngx-loading>
      Sauvegarder</button>
</form>
